import Header from "../../Components/Header"
import ImagesCertifications from "../../Components/certificates"
import certificate from "../../imagens/certificates/certificate.png"
import certificate2 from "../../imagens/certificates/certificate2.png"

const galleryImages = [
    {
        img: certificate
    },
    {
        img: certificate2
    },
]

function Certifications() {
    return (
        <div>
            <Header></Header>
            <div className="">
                <ImagesCertifications
                    galleryImages={galleryImages}
                />
            </div>
        </div>
    )
}

export default Certifications